import React from "react";
import { Heart } from "lucide-react";
import { useFavoriteToggle } from "../hooks";
import { useMe } from "../../users/hooks/useMe";

interface FavoriteButtonProps {
  productId: number;
  showLabel?: boolean;
  size?: number;
  className?: string;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  productId,
  showLabel = false,
  size = 20,
  className = "",
}) => {
  const { isFavorite, toggleFavorite, loading, isToggling } =
    useFavoriteToggle();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    await toggleFavorite(productId);
  };

  const isInFavorites = isFavorite(productId);

  return (
    <button
      onClick={handleClick}
      disabled={loading || isToggling}
      className={`
        inline-flex items-center gap-2 px-2 py-1 rounded-md transition-all
        ${
          isInFavorites
            ? "text-red-600 hover:text-red-700 hover:bg-red-50"
            : "text-gray-400 hover:text-red-600 hover:bg-gray-50"
        }
        ${
          loading || isToggling
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer"
        }
        ${className}
      `}
      title={isInFavorites ? "Retirer des favoris" : "Ajouter aux favoris"}
    >
      <Heart
        size={size}
        fill={isInFavorites ? "currentColor" : "none"}
        className="transition-all"
      />
      {showLabel && (
        <span className="text-sm font-medium">
          {isInFavorites ? "En favoris" : "Ajouter"}
        </span>
      )}
    </button>
  );
};
